export const verbs = [
    {
        'id': 'verb/sein',
        'word': 'sein',
        'english': 'to be',
        'sentence': 'verliebt sein',
        't': 'to be in love'
    },
    {
        'id': 'verb/werden',
        'word': 'werden',
        'english': 'to become, to get, will',
        'sentence': 'Wir werden am Wochenende umziehen.',
        't': 'We will be moving house this weekend.'
    },
    {
        'id': 'verb/haben',
        'word': 'haben',
        'english': 'to have',
        'sentence': 'Kinder haben sehr viel Fantasie.',
        't': 'Children have a lot of imagination.'
    },
    {
        'id': 'verb/können',
        'word': 'können',
        'english': 'to be able to, to can',
        'sentence': 'Gemeinsam können wir viel erreichen!',
        't': 'Together we can achieve a lot!'
    },
    {
        'id': 'verb/sagen',
        'word': 'sagen',
        'english': 'to say, to tell',
        'sentence': 'Kannst du mir sagen, wie spät es ist?',
        't': 'Can you tell me what time it is?'
    },
    {
        'id': 'verb/geben',
        'word': 'geben',
        'english': 'to give, to provide',
        'sentence': 'Könntest du mir bitte das Handy geben?',
        't': 'Could you give me the phone, please?'
    },
    {
        'id': 'verb/müssen',
        'word': 'müssen',
        'english': 'to have to, to need to, to must',
        'sentence': 'Wir müssen unsere Erde und die Umwelt schützen!',
        't': 'We have to protect our earth and the environment!'
    },
    {
        'id': 'verb/sollen',
        'word': 'sollen',
        'english': 'should, shall, to ought to, to be supposed to',
        'sentence': 'Soll ich dir ein Geheimnis verraten?',
        't': 'Should I tell you a secret?'
    },
    {
        'id': 'verb/gehen',
        'word': 'gehen',
        'english': 'to go, to walk, to leave',
        'sentence': 'In welche Richtung muss ich gehen?',
        't': 'In which direction do I have to go?'
    },
    {
        'id': 'verb/kommen',
        'word': 'kommen',
        'english': 'to come, to arrive',
        'sentence': 'Heute kommen alle meine Geschwister und deren Kinder zu Besuch.',
        't': 'Today all my siblings and their children are coming to visit.'
    },
    {
        'id': 'verb/wollen',
        'word': 'wollen',
        'english': 'to want',
        'sentence': 'Wollen wir uns an diesen Tisch setzen?',
        't': 'Shall we sit down at this table?'
    },
    {
        'id': 'verb/machen',
        'word': 'machen',
        'english': 'to do, to make',
        'sentence': 'Wir machen einen Ausflug mit der ganzen Familie.',
        't': 'We\'re going on a trip with the whole family.'
    },
    {
        'id': 'verb/stehen',
        'word': 'stehen',
        'english': 'to stand, to be',
        'sentence': 'Wie lange kannst du auf einem Bein stehen?',
        't': 'How long can you stand on one leg?'
    },
    {
        'id': 'verb/finden',
        'word': 'finden',
        'english': 'to find, to think, to locate, to discover',
        'sentence': 'suchen ↔ finden',
        't': 'to search ↔ to find'
    },
    {
        'id': 'verb/lassen',
        'word': 'lassen',
        'english': 'to let, to allow, to leave',
        'sentence': 'Lass uns woanders hingehen!',
        't': 'Let\'s go somewhere else!'
    },
    {
        'id': 'verb/sehen',
        'word': 'sehen',
        'english': 'to see, to view, to watch',
        'sentence': 'Hallo! Schön, dich zu sehen.',
        't': 'Hello! Good to see you.'
    },
    {
        'id': 'verb/bleiben',
        'word': 'bleiben',
        'english': 'to stay, to remain',
        'sentence': 'Bleiben Sie auf der rechten Spur und nehmen Sie die nächste Ausfahrt.',
        't': 'Stay in the right lane and take the next exit.'
    },
    {
        'id': 'verb/liegen',
        'word': 'liegen',
        'english': 'to lie, to be located, to be situated',
        'sentence': 'Die Jungen liegen im grünen Gras.',
        't': 'The boys are lying in the green grass.'
    },
    {
        'id': 'verb/zeigen',
        'word': 'zeigen',
        'english': 'to show, to demonstrate, to point, to indicate',
        'sentence': 'Zeigst du mir deine Urlaubsfotos?',
        't': 'Will you show me your holiday photos?'
    },
    {
        'id': 'verb/dürfen',
        'word': 'dürfen',
        'english': 'to be allowed, may, can',
        'sentence': 'Entschuldigung, Sie dürfen hier nicht rauchen.',
        't': 'Excuse me, you\'re not allowed to smoke here.'
    },
    {
        'id': 'verb/stellen',
        'word': 'stellen',
        'english': 'to put (vertically), to place, to position, to set, to provide',
        'sentence': 'Ich stelle die Bücher ins Regal.',
        't': 'I put the books on the shelf.'
    },
    {
        'id': 'verb/nehmen',
        'word': 'nehmen',
        'english': 'to take, to have, to use',
        'sentence': 'Du kannst dir eine Tasse aus dem Schrank nehmen.',
        't': 'You can take a cup from the cupboard.'
    },
    {
        'id': 'verb/bringen',
        'word': 'bringen',
        'english': 'to bring, to take',
        'sentence': 'Heute Nachmittag bringe ich mein Auto zur Reparatur.',
        't': 'I\'m taking my car in for repairs this afternoon.'
    },
    {
        'id': 'verb/erklären',
        'word': 'erklären',
        'english': 'to explain, to declare',
        'sentence': 'Kannst du mir das erklären?',
        't': 'Can you explain that to me?'
    },
    {
        'id': 'verb/spielen',
        'word': 'spielen',
        'english': 'to play, to gamble, to act, to perform',
        'sentence': 'Die Kinder spielen auf der Straße.',
        't': 'The children are playing in the street.'
    },
    {
        'id': 'verb/halten',
        'word': 'halten',
        'english': 'to stop, to hold, to keep, to last',
        'sentence': 'jemanden an der Hand halten',
        't': 'to hold somebody by the hand'
    },
    {
        'id': 'verb/führen',
        'word': 'führen',
        'english': 'to lead, to guide, to conduct, to manage, to wage',
        'sentence': 'einen Krieg führen',
        't': 'to wage a war'
    },
    {
        'id': 'verb/wissen',
        'word': 'wissen',
        'english': 'to know',
        'sentence': 'Wissen Sie, wie spät es ist?',
        't': 'Do you know what time it is?'
    },
    {
        'id': 'verb/setzen',
        'word': 'setzen',
        'english': 'to set, to place, to put',
        'sentence': 'Setzen Sie das bitte auf meine Rechnung.',
        't': 'Please put this on my bill.'
    },
    {
        'id': 'verb/sich-setzen',
        'word': 'sich setzen',
        'english': 'to sit down, to take seat, to settle',
        'sentence': 'Wollen wir uns an diesen Tisch setzen?',
        't': 'Shall we sit down at this table?'
    },
    {
        'id': 'verb/bekommen',
        'word': 'bekommen',
        'english': 'to get, to receive',
        'sentence': 'erhalten (formell) = bekommen = kriegen (ugs.)',
        't': 'to receive'
    },
    {
        'id': 'verb/heißen',
        'word': 'heißen',
        'english': 'to be called, to mean',
        'sentence': 'Entschuldigung, wie heißen Sie?',
        't': 'Excuse me, what\'s your name?'
    },
    {
        'id': 'verb/tun',
        'word': 'tun',
        'english': 'to do',
        'sentence': 'Es ist besser zu handeln, statt nichts zu tun.',
        't': 'It is better to act than to do nothing.'
    },
    {
        'id': 'verb/gehören',
        'word': 'gehören',
        'english': 'to belong to, to be part of',
        'sentence': 'Sind das deine Schuhe? - Nein, die gehören mir nicht.',
        't': 'Are these your shoes? - No, they\'re not mine.'
    },
    {
        'id': 'verb/erhalten',
        'word': 'erhalten',
        'english': 'to receive, to get, to obtain, to preserve, to maintain',
        'sentence': 'erhalten (formell) = bekommen = kriegen (ugs.)',
        't': 'to receive'
    },
    {
        'id': 'verb/beginnen',
        'word': 'beginnen',
        'english': 'to begin, to start, to commence',
        'sentence': 'Viele Märchen beginnen mit „Es war einmal...“.',
        't': 'Many fairy tales begin with "Once upon a time...".'
    },
    {
        'id': 'verb/mögen',
        'word': 'mögen',
        'english': 'to like, to want',
        'sentence': 'Viele Kinder mögen kein Gemüse.',
        't': 'Many children do not like vegetables.'
    },
    {
        'id': 'verb/sprechen',
        'word': 'sprechen',
        'english': 'to speak, to talk',
        'sentence': 'sprechen ↔ schweigen',
        't': 'to speak ↔ to remain silent'
    },
    {
        'id': 'verb/gelten',
        'word': 'gelten',
        'english': 'to be valid, to apply, to be effective, to be regarded as, to be considered as',
        'sentence': 'Die Regeln gelten für alle gleich.',
        't': 'The rules apply equally to all.'
    },
    {
        'id': 'verb/arbeiten',
        'word': 'arbeiten',
        'english': 'to work',
        'sentence': 'Ich arbeite jeden Tag acht Stunden.',
        't': 'I work eight hours a day.'
    },
    {
        'id': 'verb/brauchen',
        'word': 'brauchen',
        'english': 'to need, to require',
        'sentence': 'Um die Vorhänge aufzuhängen, brauchen wir eine hohe Leiter.',
        't': 'To hang the curtains, we need a high ladder.'
    },
    {
        'id': 'verb/bieten',
        'word': 'bieten',
        'english': 'to offer, to provide, to bid',
        'sentence': 'Den Urlaub im Reisebüro zu buchen spart Zeit und bietet Sicherheit.',
        't': 'Booking your holiday at a travel agency saves time and offers security.'
    },
    {
        'id': 'verb/fahren',
        'word': 'fahren',
        'english': 'to drive, to ride, to go',
        'sentence': 'mit dem Fahrrad fahren',
        't': 'to go by bike'
    },
    {
        'id': 'verb/schreiben',
        'word': 'schreiben',
        'english': 'to write',
        'sentence': 'mit dem Stift schreiben',
        't': 'to write with a pen'
    },
    {
        'id': 'verb/leben',
        'word': 'leben',
        'english': 'to live',
        'sentence': 'Wo leben Sie?',
        't': 'Where do you live?'
    },
    {
        'id': 'verb/bestehen',
        'word': 'bestehen',
        'english': 'to exist, to insist, to pass, to consist, to persist',
        'sentence': 'In Deutschland besteht eine Postleitzahl aus fünf Ziffern.',
        't': 'In Germany, a postcode consists of five digits.'
    },
    {
        'id': 'verb/denken',
        'word': 'denken',
        'english': 'to think',
        'sentence': 'Erst das Gehirn einschalten, dann denken!',
        't': 'First switch on the brain, then think!'
    },
    {
        'id': 'verb/laufen',
        'word': 'laufen',
        'english': 'to run, to go, to walk',
        'sentence': 'Meine Nase läuft. Hast du ein Taschentuch für mich?',
        't': 'My nose is running. Do you have a tissue for me?'
    },
    {
        'id': 'verb/sitzen',
        'word': 'sitzen',
        'english': 'to sit, to perch',
        'sentence': 'Wir sitzen im Park auf einer Bank und unterhalten uns.',
        't': 'We sit on a bench in the park and talk.'
    },
    {
        'id': 'verb/entsprechen',
        'word': 'entsprechen',
        'english': 'to correspond to, to meet, to comply with',
        'sentence': 'Entspricht die Unterkunft deiner Erwartung?',
        't': 'Does the accommodation meet your expectations?'
    },
    {
        'id': 'verb/glauben',
        'word': 'glauben',
        'english': 'to believe, to think',
        'sentence': 'an Gott glauben',
        't': 'to believe in God'
    },
    {
        'id': 'verb/nennen',
        'word': 'nennen',
        'english': 'to name, to call',
        'sentence': 'Wir nennen unseren Hund Bello.',
        't': 'We call our dog Bello.'
    },
    {
        'id': 'verb/scheinen',
        'word': 'scheinen',
        'english': 'to shine, to seem, to appear',
        'sentence': 'Nachts scheint der Mond ins Zimmer.',
        't': 'At night the moon shines into the room.'
    },
    {
        'id': 'verb/ziehen',
        'word': 'ziehen',
        'english': 'to pull, to drag, to draw, to move',
        'sentence': 'Wegen der hohen Mieten ziehen viele Münchner von der Stadt ins Umland.',
        't': 'Because of the high rents, many Munich residents move from the city to the surrounding area.'
    },
    {
        'id': 'verb/treffen',
        'word': 'treffen',
        'english': 'to meet, to make, to hit, to strike',
        'sentence': 'Um welche Uhrzeit treffen wir uns morgen?',
        't': 'What time are we meeting tomorrow?'
    },
    {
        'id': 'verb/entstehen',
        'word': 'entstehen',
        'english': 'to arise, to originate, to develop, to form, to emerge',
        'sentence': 'Sobald der Lehrer das Klassenzimmer verlässt, entsteht Unruhe.',
        't': 'As soon as the teacher leaves the classroom, unrest arises.'
    },
    {
        'id': 'verb/fragen',
        'word': 'fragen',
        'english': 'to ask',
        'sentence': 'fragen ↔ antworten',
        't': 'to ask ↔ to answer'
    },
    {
        'id': 'verb/sich-fragen',
        'word': 'sich fragen',
        'english': 'to wonder',
        'sentence': 'Ich frage mich, warum ich das tun sollte. Nenn mir bitte einen Grund!',
        't': 'I wonder why I should do that. Please give me one reason!'
    },
    {
        'id': 'verb/fallen',
        'word': 'fallen',
        'english': 'to fall, to drop, to decline',
        'sentence': 'Im Herbst fallen die Blätter von den Bäumen.',
        't': 'In autumn, the leaves fall from the trees.'
    },
    {
        'id': 'verb/legen',
        'word': 'legen',
        'english': 'to lay, to put (horizontally), to place, to set',
        'sentence': 'Legen Sie die Post bitte auf meinen Schreibtisch.',
        't': 'Please put the mail on my desk.'
    },
    {
        'id': 'verb/(sich)-vorstellen',
        'word': '(sich) vorstellen',
        'english': 'to introduce, to present, to imagine, to picture, to envisage',
        'sentence': 'Darf ich mich vorstellen? Mein Name ist Markus Meier.',
        't': 'May I introduce myself? My name is Markus Meier.'
    },
    {
        'id': 'verb/meinen',
        'word': 'meinen',
        'english': 'to think, to mean, to say',
        'sentence': 'Wenn ein Deutscher ‚ein Pfund‘ sagt, meint er 500 (fünfhundert) Gramm.',
        't': 'When a German says ‘one pound‘, he means 500 (five hundred) grams.'
    },
    {
        'id': 'verb/suchen',
        'word': 'suchen',
        'english': 'to search, to look for, to seek',
        'sentence': 'suchen ↔ finden',
        't': 'to search ↔ to find'
    },
    {
        'id': 'verb/erreichen',
        'word': 'erreichen',
        'english': 'to achieve, to reach, to attain, to accomplish, to gain',
        'sentence': 'Gemeinsam können wir viel erreichen!',
        't': 'Together we can achieve a lot!'
    },
    {
        'id': 'verb/handeln',
        'word': 'handeln',
        'english': 'to deal, to trade, to act, to take action',
        'sentence': 'Es ist besser zu handeln, statt nichts zu tun.',
        't': 'It is better to act than to do nothing.'
    },
    {
        'id': 'verb/tragen',
        'word': 'tragen',
        'english': 'to carry, to wear',
        'sentence': 'Diese Kiste ist sehr schwer, die kann ich nicht alleine tragen.',
        't': 'The box is very heavy, I can\'t carry it alone.'
    },
    {
        'id': 'verb/lesen',
        'word': 'lesen',
        'english': 'to read',
        'sentence': 'Kannst du lesen was auf dem Schild steht?',
        't': 'Can you read what the sign says?'
    },
    {
        'id': 'verb/schaffen',
        'word': 'schaffen',
        'english': 'to make, to create, to manage',
        'sentence': 'Kannst du mir helfen, die Kiste zu tragen? Ich schaffe das nicht allein.',
        't': 'Can you help me carry the box? I can\'t do it alone.'
    },
    {
        'id': 'verb/kennen',
        'word': 'kennen',
        'english': 'to know',
        'sentence': 'Kennen Sie diese Gegend? - Nein, ich bin zum ersten Mal hier.',
        't': 'Do you know this area? - No, this is my first time here.'
    },
    {
        'id': 'verb/darstellen',
        'word': 'darstellen',
        'english': 'to depict, to present, to represent, to portray, to pose',
        'sentence': 'Was soll das Bild darstellen? - Eine glückliche Familie!',
        't': 'What is the picture supposed to represent? - A happy family!'
    },
    {
        'id': 'verb/verlieren',
        'word': 'verlieren',
        'english': 'to lose',
        'sentence': 'siegen / gewinnen ↔ verlieren',
        't': 'to win ↔ to lose'
    },
    {
        'id': 'verb/entwickeln',
        'word': 'entwickeln',
        'english': 'to develop',
        'sentence': 'Manche Freundschaften entstehen beim ersten Kennenlernen, andere brauchen Jahre, um sich zu entwickeln.',
        't': 'Some friendships are formed when you first meet, others take years to develop.'
    },
    {
        'id': 'verb/reden',
        'word': 'reden',
        'english': 'to talk, to speak',
        'sentence': 'Reden ist Silber, Schweigen ist Gold.',
        't': 'Speech is silver, silence is gold.'
    },
    {
        'id': 'verb/erkennen',
        'word': 'erkennen',
        'english': 'to recognize, to recognise, to see, to identify, to detect',
        'sentence': 'Woran erkennt man, dass jemand lügt?',
        't': 'How can you tell if someone is lying?'
    },
    {
        'id': 'verb/erscheinen',
        'word': 'erscheinen',
        'english': 'to appear, to seem, to be published, to be released, to come out',
        'sentence': 'erscheinen / auftauchen ↔ verschwinden',
        't': 'to appear ↔ to disappear'
    },
    {
        'id': 'verb/aussehen',
        'word': 'aussehen',
        'english': 'to appear, to look',
        'sentence': 'Diese Pflege lässt gereizte Haut wieder strahlen und frisch aussehen.',
        't': 'This care makes irritated skin look radiant and fresh again.'
    },
    {
        'id': 'verb/folgen',
        'word': 'folgen',
        'english': 'to follow',
        'sentence': 'Auf Regen folgt Sonnenschein.',
        't': 'Rain is followed by sunshine. (Every cloud has a silver lining.)'
    },
    {
        'id': 'verb/anfangen',
        'word': 'anfangen',
        'english': 'to begin, to start',
        'sentence': 'Es kann jeden Moment anfangen zu regnen.',
        't': 'It could start raining at any moment.'
    },
    {
        'id': 'verb/versuchen',
        'word': 'versuchen',
        'english': 'to try, to attempt',
        'sentence': 'Ich werde versuchen in Zukunft pünktlich zu sein.',
        't': 'I will try to be on time in the future.'
    },
    {
        'id': 'verb/bilden',
        'word': 'bilden',
        'english': 'to form, to educate',
        'sentence': 'Liebe, Vertrauen und Respekt bilden die Basis einer guten Beziehung.',
        't': 'Love, trust and respect form the basis of a good relationship.'
    },
    {
        'id': 'verb/lernen',
        'word': 'lernen',
        'english': 'to learn, to study',
        'sentence': 'Ich lerne erst seit vier Wochen Deutsch.',
        't': 'I\'ve only been learning German for four weeks.'
    },
    {
        'id': 'verb/erwarten',
        'word': 'erwarten',
        'english': 'to expect, to await, to anticipate',
        'sentence': 'Die Veranstalter des Festivals erwarten in dieser Saison 25.000 (fünfundzwanzigtausend) Besucher.',
        't': 'The organisers of the festival expect 25,000 (twenty-five thousand) visitors this season.'
    },
    {
        'id': 'verb/betreffen',
        'word': 'betreffen',
        'english': 'to affect, to concern, to relate to',
        'sentence': 'Politische Entscheidungen, die auf nationaler Ebene getroffen werden, betreffen die gesamte Bevölkerung.',
        't': 'Political decisions made at national level affect the entire population.'
    },
    {
        'id': 'verb/wohnen',
        'word': 'wohnen',
        'english': 'to live, to dwell, to reside',
        'sentence': 'in einer Wohnung wohnen',
        't': 'to live in a flat'
    },
    {
        'id': 'verb/warten',
        'word': 'warten',
        'english': 'to wait, to await, to maintain, to service',
        'sentence': 'Ich warte an der Haltestelle auf den Bus.',
        't': 'I wait for the bus at the bus stop.'
    },
    {
        'id': 'verb/verstehen',
        'word': 'verstehen',
        'english': 'to understand, to comprehend, to apprehend',
        'sentence': 'Aha, jetzt verstehe ich das.',
        't': 'Aha, now I understand that.'
    },
    {
        'id': 'verb/helfen',
        'word': 'helfen',
        'english': 'to help, to aid, to assist',
        'sentence': 'Kann ich dir helfen?',
        't': 'Can I help you?'
    },
    {
        'id': 'verb/gewinnen',
        'word': 'gewinnen',
        'english': 'to win, to gain',
        'sentence': 'siegen / gewinnen ↔ verlieren',
        't': 'to win ↔ to lose'
    },
    {
        'id': 'verb/fühlen',
        'word': 'fühlen',
        'english': 'to feel, to sense',
        'sentence': 'Ich fühle mich krank, daher bleibe ich heute zu Hause.',
        't': 'I feel sick, so I will stay at home today.'
    },
    {
        'id': 'verb/interessieren',
        'word': 'interessieren',
        'english': 'to interest',
        'sentence': 'Sollen die Leute doch reden. Es interessiert mich nicht, was sie denken.',
        't': 'Let people talk. I don\'t care what they think.'
    },
    {
        'id': 'verb/sich-interessieren',
        'word': 'sich interessieren',
        'english': 'to be interested in',
        'sentence': 'Interessierst du dich für moderne Kunst?',
        't': 'Are you interested in modern art?'
    },
    {
        'id': 'verb/erinnern',
        'word': 'erinnern',
        'english': 'to remind',
        'sentence': 'Die Form der Wolke erinnert mich an einen Fisch.',
        't': 'The shape of the cloud reminds me of a fish.'
    },
    {
        'id': 'verb/sich-erinnern',
        'word': 'sich erinnern',
        'english': 'to remember',
        'sentence': 'Ich erinnere mich noch sehr gut an unser erstes Treffen.',
        't': 'I still remember our first meeting very well.'
    },
    {
        'id': 'verb/schließen',
        'word': 'schließen',
        'english': 'to close, to shut',
        'sentence': 'öffnen / aufmachen (ugs.) ↔ schließen / zumachen (ugs.)',
        't': 'to open ↔ to close'
    },
    {
        'id': 'verb/anbieten',
        'word': 'anbieten',
        'english': 'to offer',
        'sentence': 'Kann ich dir eine Tasse Tee anbieten?',
        't': 'Can I offer you a cup of tea?'
    },
    {
        'id': 'verb/ergeben',
        'word': 'ergeben',
        'english': 'to result in, to show, to give, to produce, to yield',
        'sentence': 'Rot und Blau gemischt ergibt Lila.',
        't': 'Mixing red and blue makes purple.'
    },
    {
        'id': 'verb/sich-ergeben',
        'word': 'sich ergeben',
        'english': 'to surrender',
        'sentence': 'Bitte nicht schießen. Ich ergebe mich!',
        't': 'Please don\'t shoot. I surrender!'
    },
    {
        'id': 'verb/bedeuten',
        'word': 'bedeuten',
        'english': 'to mean, to signify',
        'sentence': 'Die Redewendung "Licht ins Dunkel bringen" bedeutet, Klarheit in eine Angelegenheit zu bringen.',
        't': 'The idiom "to bring light into the darkness" means to bring clarity to a matter.'
    },
    {
        'id': 'verb/verbinden',
        'word': 'verbinden',
        'english': 'to connect, to link, to combine, to join',
        'sentence': 'verbinden ↔ trennen',
        't': 'connect ↔ disconnect'
    },
    {
        'id': 'verb/studieren',
        'word': 'studieren',
        'english': 'to study',
        'sentence': 'Ich habe die Chance ein Jahr im Ausland zu studieren.',
        't': 'I have the chance to study abroad for a year.'
    }
]